import { AtsJobPostingStatusesEnum } from 'generated/resources/graphql'
import { capitalize } from 'lodash'

import i18n from 'modules/core/lib/i18n'

export type JobStatus = keyof typeof JOB_STATUSES

export enum JOB_STATUSES {
  draft = 'draft',
  published = 'published',
  archived = 'archived',
  unlisted = 'unlisted',
  cancelled = 'cancelled',
}

export const CONTRACT_TYPES = {
  indefinite: 'indefinite',
  temporary: 'temporary',
  fixed_discontinued: 'fixed_discontinued',
  intern: 'intern',
  training: 'training',
  freelance: 'freelance',
  vendor_contractor: 'vendor_contractor',
  volunteer: 'volunteer',
  per_hour: 'per_hour',
  other: 'other',
  alternant: 'alternant',
  interim: 'interim',
  minijob: 'minijob',
  werkstudent: 'werkstudent',
  apprenticeship: 'apprenticeship',
  jovem_aprendiz: 'jovem_aprendiz',
  pj: 'pj',
  clt: 'clt',
  a_termo_incerto: 'a_termo_incerto',
  apprentissage: 'apprentissage',
  apprendistato: 'apprendistato',
}

const SCHEDULE_TYPES = {
  fullTime: 'full_time',
  partTime: 'part_time',
}

export const jobStatusLabel = (status?: string | null): string => {
  switch (status) {
    case JOB_STATUSES.draft:
      return i18n.t('ats.job_status.draft')

    case JOB_STATUSES.published:
      return i18n.t('ats.job_status.active')

    case JOB_STATUSES.archived:
      return i18n.t('ats.job_status.archived')

    case JOB_STATUSES.unlisted:
      return i18n.t('ats.job_status.unlisted')

    case JOB_STATUSES.cancelled:
      return i18n.t('ats.job_status.cancelled')

    default:
      throw new Error(`Ats Job status: ${status} not valid`)
  }
}

export const isJobActive = (status: AtsJobPostingStatusesEnum) =>
  status !== 'archived' && status !== 'cancelled'

export const isJobOpen = (status: AtsJobPostingStatusesEnum) =>
  status === 'published' || status === 'unlisted'

export const jobContractTypeLabel = (contractType?: string | null): string => {
  switch (contractType) {
    case null:
    case undefined:
      return i18n.t('ats.job_contract.not_set')
    case CONTRACT_TYPES.indefinite:
      return i18n.t('ats.job_contract.indefinite')
    case CONTRACT_TYPES.temporary:
      return i18n.t('ats.job_contract.temporary')
    case CONTRACT_TYPES.fixed_discontinued:
      return i18n.t('ats.job_contract.fixed_discontinued')
    case CONTRACT_TYPES.intern:
      return i18n.t('ats.job_contract.intern')
    case CONTRACT_TYPES.training:
      return i18n.t('ats.job_contract.training')

    default:
      return capitalize(contractType.split('_').join(' '))
  }
}

export const jobScheduleTypeLabel = (scheduleType?: string | null): string => {
  switch (scheduleType) {
    case null:
      return i18n.t('ats.job_schedule.not_set')
    case SCHEDULE_TYPES.fullTime:
      return i18n.t('ats.job_schedule.full_time')
    case SCHEDULE_TYPES.partTime:
      return i18n.t('ats.job_schedule.part_time')

    default:
      throw new Error(`Ats Job schedule type: ${scheduleType} not valid`)
  }
}
